import getConfiguration from "./config.js";
import { getSecurityComponentsVersion } from "./bisc.js";
import { handleServiceException } from "./errors";

const allowedVersions = {};
let allowHigherVersions = false;

let packageVersion = '0';
let prototype = false;
let deprecated = false;

function getOS () {
    return navigator.platform.match(/win/i) ? 'windows' : navigator.platform.match(/mac/i) ? 'macintosh' : 'unknown';
}

function isVersionAuthorized (version) {
    const sortVersionNumber = (a, b) => a.localeCompare(b);
    const acceptedVersions = allowedVersions.accepted.sort(sortVersionNumber);
    const deprecatedVersions = allowedVersions.deprecated;

    if (acceptedVersions.includes(version)){
        return true;
    } else if(deprecatedVersions && deprecatedVersions.includes(version)) {
        deprecated = true; // it is in the deprecated versions list
        return true;
    } else if (version > acceptedVersions[acceptedVersions.length - 1]) {
        prototype = true; // it is a prototype version
        return allowHigherVersions;
    }
    return false;
}

export function checkPackageVersion (version) {
    return new Promise((resolve, reject) => {
        getConfiguration()
            .then(result => {
                Object.assign(allowedVersions, result.allowedVersions[getOS()]);
                allowHigherVersions = result.allowHigherVersions;
                packageVersion = version;
                resolve({
                    authorized: isVersionAuthorized(version),
                    prototype,
                    deprecated
                });
            })
            .catch(error => {
                reject(error);
            });
    });
}

export function getPackageVersionInfo() {
    return new Promise((resolve, reject) => {
        getConfiguration()
            .then(result => {
                Object.assign(allowedVersions, result.allowedVersions[getOS()]);
                const versionList = allowedVersions.accepted.concat(allowedVersions.deprecated);
                const info = {
                    current: packageVersion,
                    minimal: versionList.sort((a, b) => a.localeCompare(b))[0]
                };
                if (packageVersion === '0') {
                    getSecurityComponentsVersion()
                        .then(version => {
                            Object.assign(info, { current: version });
                            packageVersion = version;
                            resolve(info);
                        })
                        .catch(handleServiceException);
                } else {
                    resolve(info);
                }
            })
            .catch(error => {
                reject(error);
            });
    });
}

export function getPackageVersion() {
    return packageVersion;
}